import React, { Component } from 'react';

import {
    Select,
    DatePicker,
    Modal,
    Button,
    Input,
    Tooltip,
    Icon,
    TimePicker,
    Spin,
    Popover
} from 'antd';
import { formDataSchema, formData2Schema, formData3Schema, preExistingForm, intermForm, ailmentFrorm, preExistFormFEild, addonSchema } from '../../../../schema/insurance-counselling';
import { filter, formData, dissableFormData } from '../../../../schema/apppointment';
import Datepicker from '../../../../components/FormComponent/Date';
import Select2 from '../../../../components/FormComponent/select2';
import Select2multiple from '../../../../components/FormComponent/select2/multiple';
import Inputlayer from '../../../../components/FormComponent/Input';
import CheckboxLayer from './../../../../components/FormComponent/CheckboxLayer';
import Storage from './../../../../services/local-store';
import networkList from '../../../../constants/networkList';
import postService from '../../../../services/httpService';
import Ins_upload from '../Insurance-Counselling/upload';
import moment from 'moment';
import Finanical_clearance from './finanical-clearance';

const $ = require('jquery');
const { Option } = Select;
class View_Insurance_Counselling extends Component {
    constructor(props) {
        super(props)
        this.state = {
            visible: false,
            preExistince: true,
            alinmentTable: true,
            total_estimate: 0,
            formData: [],
            loadding: false,
        }
    }
    showModal = () => {
        this.setState({
            visible: true
        })
    }
    componentDidMount() {
        let tokenData = JSON.parse(Storage.get('current_token'));

        formDataSchema['feilds'].map((data, key) => {
            formDataSchema['feilds'][key]['value'] = null;
            formDataSchema['feilds'][key]['text'] = null;
        })

        formData2Schema['feilds'].map((data, key) => {
            formData2Schema['feilds'][key]['value'] = null;
            formData2Schema['feilds'][key]['text'] = null;
            if (data['type'] !== undefined) {
                data['data'].map((subdata, subKey) => {
                    formData2Schema['feilds'][key]['data'][subKey]['value'] = null;
                    formData2Schema['feilds'][key]['data'][subKey]['text'] = null;
                })
            }
        })

        formData3Schema['feilds'].map((data, key) => {
            formData3Schema['feilds'][key]['value'] = null;
            formData3Schema['feilds'][key]['text'] = null;
        })

        preExistFormFEild['feilds'].map((data, key) => {
            preExistFormFEild['feilds'][key]['value'] = null;
            preExistFormFEild['feilds'][key]['text'] = null;
        })
        const params = new URLSearchParams(this.props.location.search);
        const nav_from = params.get('nav_from')
        this.setState((state) => ({ 'addonSchema': addonSchema['feilds'], 'preExistFormFEild': preExistFormFEild['feilds'], 'ailmentFrorm': ailmentFrorm['feilds'], 'formData2': formData2Schema['feilds'], 'formData3': formData3Schema['feilds'], 'formData': formDataSchema['feilds'], 'token_data': tokenData, 'preExistingForm': preExistingForm['feilds'], 'intermForm': intermForm['feilds'], 'nav_from': nav_from }), () => {
            const params = new URLSearchParams(this.props.location.search);
            const tags = params.get('rid');
            const ip = params.get('ip');
            if ((tags !== undefined && tags !== null && tags !== '') || (ip !== undefined && ip !== null && ip !== '')) {
                this.renderBodydata(tags, ip);
            } else {
                this.cancelButton();
            }
            // if (tags !== undefined && tags !== null && tags !== '') {
            //     this.renderBodydata(tags);
            // } else {
            //     this.renderBody();
            // }
        })

    }
    

    cancelButton() {
        const params = new URLSearchParams(this.props.location.search);
        const nav_from = params.get('nav_from');
        const ip_id = params.get('nav_ip');        
        const umr_no = params.get('umr');
        const unit_id = params.get('unit_id');

        if (nav_from) {
            this.props
                .history
                .push(`/${nav_from}?nav_ip=${ip_id}`);
        }else if(unit_id){
            // navigation to patients-history
            this.props.history.push(`/patients-history?umr=${umr_no}&unit_id=${unit_id}`);
        }else{
            this.props
            .history
            .push(`/counselling/counselling-list`);
        }

    }

    caluculateTotal() {
        let { formData, addonSchema } = this.state;
        let percentage_change = localStorage.getItem('percentage_change')
        let total_cost = 0;

        addonSchema.map((adata, akey) => {
            if (adata['value'] !== undefined && adata['value'] !== null && adata['value'] !== '') {
                total_cost = total_cost + parseFloat(adata['value'])
            }
        });

        // if(percentage_change !== null){
        //     total_cost = (total_cost * (parseFloat(percentage_change)/100)).toFixed(2)
        // }

        this.setState((state) => ({ 'total_estimate': total_cost }))
    }

    getPercentageChange(oldNumber, newNumber) {
        var decreaseValue = oldNumber - newNumber;

        return (decreaseValue / oldNumber) * 100;
    }

  
  

  

  


    renderBodydata(tags,ip) {
        let { formData, formData2, formData3, token_data, preExistingForm, intermForm, ailmentFrorm, preExistFormFEild,addonSchema } = this.state;
        let { getConusellingDetails } = networkList;
        let payload = {
            "ip_no": ip?ip:null,
            "counselling_id": tags ? tags : null
        }

      

        postService(getConusellingDetails, 'POST', { 'data': payload }).then(res => {
            console.log(res);
            this.setState((state) => ({ loadding: false }));
            if (res.data && Array.isArray(res['data']) && res['data'].length !== 0) {
                let responseData = res['data'][0];
                Storage.store('counselling_save_data', payload);
                Storage.store('counselling_view', res['data']);
                let payment_type = responseData['payment_type'];
                this.setState({print_payment_type: payment_type ? payment_type.toString() : ''})
                if (payment_type === 2) {
                    this.setState((state) => ({ 'payment_mode': false }));
                }

                localStorage.setItem('insurance_company', responseData['insurance_company_name_value']);
                localStorage.setItem('tpa_name', responseData['tpa_name_value']);
                localStorage.setItem('type_of_package', responseData['estimate_type_value']);
                localStorage.setItem('package_name', responseData['package_name']);
                localStorage.setItem('room_eligible_ward_cost', responseData['room_eligible_ward_amount']);

                // localStorage.removeItem('tpa_name');
                // localStorage.removeItem('type_of_package');
                // localStorage.removeItem('package_name')
                // localStorage.removeItem('room_eligible_ward_cost');


                let type_of_management = responseData['care_management'];
                let type_of_package = responseData['estimate_type'];
                let room_optd_charges = 0;
                let total_est_chargs = responseData['total_estimate_amount'] ? parseFloat(responseData['total_estimate_amount']) : '';
                let type_of_insurance = responseData['type_of_insurance'];
                let ailment_capping_status = responseData['ailment_capping_status'];
                if (type_of_insurance === 1) {
                    this.setState((state) => ({ 'preExistince': true }));
                }
                if (type_of_insurance === 2) {
                    this.setState((state) => ({ 'preExistince': false }));
                }

                if (ailment_capping_status === 1) {
                    this.setState((state) => ({ 'alinmentTable': true }));
                }
                if (ailment_capping_status === 2) {
                    this.setState((state) => ({ 'alinmentTable': false }));
                }
                formData.map((feild, key) => {

                    if (feild['name'] === 'patientname') {
                        formData[key]['value'] = responseData['patient_name'];
                        formData[key]['text'] = responseData['patient_name'];
                        formData[key]['disable'] = true;
                    }

                    if (feild['name'] === 'patient_type') {
                        formData[key]['value'] = responseData['type_of_patient'];
                        formData[key]['text'] = responseData['type_of_patient_value'];
                        formData[key]['disable'] = false;
                    }

                    if (feild['name'] === 'type_of_insurance') {
                        formData[key]['value'] = responseData['type_of_insurance'];
                        formData[key]['text'] = responseData['type_of_insurance_value'];
                        formData[key]['disable'] = false;
                    }
                    if(responseData['type_of_insurance'] === 2){
                        // if corporate show emp name
                        if (feild['name'] === 'corporate_name') {
                            formData[key]['value'] = responseData['corporate_name'];
                            formData[key]['text'] = responseData['corporate_name'];
                            formData[key]['disable'] = false;
                            formData[key]['visible'] = true;
                        }
                    }
                    if (feild['name'] === 'pre_auth_status') {
                        formData[key]['value'] = responseData['pre_auth_status'];
                        formData[key]['text'] = responseData['pre_auth_status_value'];
                        formData[key]['disable'] = false;
                    }
                    if (feild['name'] === 'insurance_status') {
                        formData[key]['value'] = responseData['insurance_status'];
                        formData[key]['text'] = responseData['insurance_status_value'];
                        formData[key]['disable'] = true;
                    }

                    if (feild['name'] === 'estimated_date_of_admission') {
                        formData[key]['value'] = responseData['estimated_date_of_admission'];
                        formData[key]['text'] = responseData['estimated_date_of_admission'];
                        formData[key]['disable'] = false;
                    }

                    if (feild['name'] === 'insurance_company') {
                        formData[key]['value'] = responseData['insurance_company_name'];
                        formData[key]['text'] = responseData['insurance_company_name_value'];
                        formData[key]['disable'] = false;
                    }

                    if (feild['name'] === 'tpa_name') {
                        formData[key]['value'] = responseData['tpa_name'];
                        formData[key]['text'] = responseData['tpa_name_value'];
                        formData[key]['disable'] = false;
                    }

                    if (feild['name'] === 'type_of_management') {
                        formData[key]['value'] = responseData['care_management'];
                        formData[key]['text'] = responseData['care_management_value'];


                    }
                    if (feild['name'] === 'type_of_package') {
                        formData[key]['value'] = responseData['estimate_type'];
                        formData[key]['text'] = responseData['estimate_type_value'];
                        if (type_of_management === 1) {
                            formData[key]['visible'] = false;
                        }

                        if (type_of_management === 2) {
                            formData[key]['visible'] = true;
                            formData[key]['disable'] = false;
                        }

                    }




                    if (feild['name'] === 'package_name') {
                        formData[key]['value'] = responseData['package_name'];
                        formData[key]['text'] = responseData['package_name_value'];

                        if (type_of_management === 1 || type_of_package === 2) {
                            formData[key]['visible'] = false;
                        }

                        if (type_of_management === 2 || type_of_package === 1) {
                            formData[key]['visible'] = true;
                            formData[key]['disable'] = false;
                        }

                    }


                    if (feild['name'] === 'length_of_stay') {
                        formData[key]['value'] = responseData['lenght_of_stay'];
                        formData[key]['text'] = responseData['lenght_of_stay'];


                    }

                    if (feild['name'] === 'surgery_procedure_name') {
                        // formData[key]['value'] = responseData['surgery_procedure_id'];
                        // formData[key]['text'] = responseData['surgery_procedure_id_value'];
                        // formData[key]['disable'] = false;
                        if(type_of_management === 1){          
                            //hide on medical
                            formData[key]['disable'] = true;
                            formData[key]['visible'] = false;
                        }
                        if(type_of_management === 2){
                            // show on surgery
                            formData[key]['value'] = responseData['surgery_procedure_id'];
                            formData[key]['text'] = responseData['surgery_procedure_id_value'];
                            formData[key]['disable'] = false;
                            formData[key]['visible'] = true;
                        }
                    }
                    if (feild['name'] === 'date_of_surgery') {
                        // formData[key]['value'] = responseData['date_of_surgery'];
                        // formData[key]['text'] = responseData['date_of_surgery'];
                        // formData[key]['visible'] = true;
                        if(type_of_management === 1){         
                            // hide on medical                     
                            formData[key]['disable'] = true;
                            formData[key]['visible'] = false;
                        }
                        if(type_of_management === 2){                               
                            // show on surgery
                            formData[key]['value'] = responseData['date_of_surgery'];
                            formData[key]['text'] = responseData['date_of_surgery'];
                            formData[key]['disable'] = false;
                            formData[key]['visible'] = true;
                        }
                    }

                    if (feild['name'] === 'estimate_amount') {
                        formData[key]['value'] = responseData['estimate_amount'];
                        formData[key]['text'] = responseData['estimate_amount'];
                        formData[key]['visible'] = true;
                    }

                    if (feild['name'] === 'additional_procedure') {
                        formData[key]['value'] = responseData['additional_procedure'];
                        formData[key]['text'] = responseData['additional_procedure'];
                        formData[key]['visible'] = true;
                    }
                    formData[key]['disable'] = true;

                })

                formData2
                    .map((data, key) => {

                        if (data['type'] && data['type'] === 'group') {
                            if (data['data'] && Array.isArray(data['data'])) {

                                data['data'].map((sub, subKey) => {
                                    Object.keys(responseData).map(resKey => {
                                        if (sub['name'] === resKey) {
                                            formData2[key]['data'][subKey]['value'] = responseData[resKey];
                                            formData2[key]['data'][subKey]['text'] = responseData[resKey];
                                            formData2[key]['data'][subKey]['disable'] = false;
                                            if (sub['input_type'] === 'select') {
                                                formData2[key]['data'][subKey]['text'] = responseData[resKey + "_value"] || responseData[resKey + "_name"];
                                            }
                                        }

                                        if (sub['name'] === 'room_eligible_ward') {
                                            localStorage.setItem('room_eligible_ward_cost', responseData['room_eligible_ward_amount']);
                                             formData2[key]['data'][subKey]['amount'] = responseData['room_eligible_ward_amount'];
                                             formData2[key]['data'][subKey]['package_id'] = responseData[resKey];
                                            
                                        }
                                        if (sub['name'] === 'upgrade_room') {
                                            
                                             formData2[key]['data'][subKey]['amount'] = responseData['upgrade_room_amount'];
                                             formData2[key]['data'][subKey]['package_id'] = responseData[resKey];
                                        }
                                    })
                                    formData2[key]['data'][subKey]['disable'] = true;
                                })
                            }

                        } else {
                            Object.keys(responseData).map(resKey => {
                                if (data['name'] === resKey) {
                                    formData2[key]['value'] = responseData[resKey];
                                    formData2[key]['text'] = responseData[resKey];
                                    formData2[key]['disable'] = false;
                                    
                                    if (data['input_type'] === 'select') {
                                        formData2[key]['text'] = responseData[resKey + "_value"] || responseData[resKey + "_name"];
                                    }


                                }
                            })


                            if (data['name'] === 'room_differance') {
                                
                                formData2[key]['disable'] = true;
                            }


                            if (data['name'] === 'pro_rata_differance') {
                               
                                formData2[key]['disable'] = true;
                            }

                            if (data['name'] === 'ailment_capping_status') {
                                formData2[key]['value'] = responseData['ailment_capping_status'];
                                if(responseData['ailment_capping_status'] === 1){
                                    formData2[key]['text'] = 'Yes';
                                }else{
                                    formData2[key]['text'] = 'No';
                                }
                                // formData2[key]['value'] = responseData['ailment_capping_status'];
                                // formData2[key]['text'] = responseData['basic_sum_insured_amt'];
                                formData2[key]['disable'] = false;
                            }

                            if (data['name'] === 'basic_sum_insured') {
                                formData2[key]['value'] = responseData['basic_sum_insured_amt'];
                                formData2[key]['text'] = responseData['basic_sum_insured_amt'];
                                formData2[key]['disable'] = false;
                            }
                            if (data['name'] === 'sum_insured_four_years_back') {
                                formData2[key]['value'] = responseData['sum_insured_4_years_back'];
                                formData2[key]['text'] = responseData['sum_insured_4_years_back'];
                                formData2[key]['disable'] = false;
                            }
                            formData2[key]['disable'] = true;

                        }

                    })


                formData3
                    .map((data, key) => {
                        Object.keys(responseData).map(resKey => {
                            if (data['name'] === resKey) {
                                formData3[key]['value'] = responseData[resKey];
                                formData3[key]['text'] = responseData[resKey];
                                formData3[key]['disable'] = false;
                            }
                        })
                        if (data['name'] === 'submitted_amount') {
                            formData3[key]['value'] = responseData['submitted_amt'];
                            formData3[key]['text'] = responseData['submitted_amt'];
                            formData3[key]['disable'] = false;
                        }
                        if (data['name'] === 'differance_amount') {
                            formData3[key]['value'] = responseData['difference_amount'];
                            formData3[key]['text'] = responseData['difference_amount'];
                            formData3[key]['disable'] = false;
                        }
                        formData3[key]['disable'] = true;
                    })





                let pre_existing_condition = responseData['pre_existing_condition'];
               
                let preExistingArray = [];
                if (pre_existing_condition && Array.isArray(pre_existing_condition)) {
                    pre_existing_condition.map((data, key) => {


                        let newFeildobj = {
                            name: 'pre_existing_group',
                            data: [{
                                id: 14,
                                name: 'condition_name',
                                title: 'condition name',
                                visible: true,
                                element: 'select2',
                                required: true,
                                input_type: 'select',
                                placeholder: 'Select',
                                icon: 'user',
                                rules: [
                                    {
                                        test: (value) => {
                                            //return (value !== null && value.length > 0);
                                            return true;
                                        },
                                        message: 'please select condition name'
                                    }
                                ],
                                errors: [],
                                value: null,
                                valid: false,
                                state: '',
                                disable: true,
                                className: 'col-3'
                            }, {
                                id: 9,
                                name: 'onset_data',
                                title: 'onset date',
                                visible: true,
                                element: 'date',
                                required: true,
                                input_type: 'date',
                                placeholder: 'Enter',
                                icon: 'user',
                                rules: [
                                    {
                                        test: (value) => {
                                            return (value !== null && value.length > 0);
                                        },
                                        message: 'Please Select onset date'
                                    }
                                ],
                                errors: [],
                                value: null,
                                valid: false,
                                state: '',
                                disable: true,
                                className: 'col-3'
                            }, {
                                id: 14,
                                name: 'sum_insured_onset_data',
                                title: 'sum insured onset date',
                                visible: true,
                                element: 'input',
                                required: true,
                                input_type: 'text',
                                placeholder: 'Select',
                                icon: 'user',
                                rules: [
                                    {
                                        test: (value) => {
                                            //return (value !== null && value.length > 0);
                                            return true;
                                        },
                                        message: 'please Enter sum insured onset date'
                                    }
                                ],
                                errors: [],
                                value: null,
                                valid: false,
                                state: '',
                                disable: false,
                                className: 'col-3'
                            }, {
                                id: 14,
                                name: 'consder_si',
                                title: 'consder si',
                                visible: true,
                                element: 'checkbox',
                                required: true,
                                input_type: 'text',
                                placeholder: 'checkbox',
                                icon: 'user',
                                rules: [
                                    {
                                        test: (value) => {
                                            //return (value !== null && value.length > 0);
                                            return true;
                                        },
                                        message: 'please Select consder si'
                                    }
                                ],
                                errors: [],
                                value: null,
                                valid: false,
                                state: '',
                                disable: true,
                                className: 'col-3'
                            }]
                        }

                        

                        newFeildobj['data'].map((feild, fkey) => {
                            // Object.keys(data).map(resKey => {
                                if (feild['name'] === 'condition_name') {
                                    newFeildobj['data'][fkey]['value'] = data['condition_name'];
                                    newFeildobj['data'][fkey]['text'] = data['condition_name_value'];
                                }
                                if (feild['name'] === 'onset_data') {
                                    newFeildobj['data'][fkey]['value'] = data['onset_data'];
                                    newFeildobj['data'][fkey]['text'] = data['onset_data'];
                                }
                                if (feild['name'] === 'sum_insured_onset_data') {
                                    newFeildobj['data'][fkey]['value'] = data['sum_insured_onset_data'] ? parseFloat(data['sum_insured_onset_data']) : '';
                                    newFeildobj['data'][fkey]['text'] = data['sum_insured_onset_data'];
                                }
                                if (feild['name'] === 'consder_si') {
                                    if (pre_existing_condition[key]['consider_sum_insured'] === 1) {
                                        newFeildobj['data'][fkey]['value'] = true;
                                    } else {
                                        newFeildobj['data'][fkey]['value'] = false;
                                    }
                                }
                                newFeildobj['data'][fkey]['disable'] = true;
                            // })
                        })

                        preExistingArray.push(newFeildobj);
                        // this.addrow('preExistingForm');
                        // preExistingArray.push(preexistingFeildobj);
                    })
                }


                preExistFormFEild.map((feild,key) => {
                    if (feild.name === 'consider_si_four_years_back') {
                        if (responseData['consider_si_four_years_back'] === 1) {
                            preExistFormFEild[key]['value'] = true;
                        } else {
                            preExistFormFEild[key]['value'] = false;
                        }
                    }
                    if (feild.name === 'sum_insured_four_years_back') {
                        preExistFormFEild[key]['text'] = responseData['sum_insured_4_years_back'];
                        preExistFormFEild[key]['value'] = (responseData['sum_insured_4_years_back']) ? parseFloat(responseData['sum_insured_4_years_back']) : '';
                    
                    }
                    preExistFormFEild[key]['disable'] = true;
                });



                let interm_approval = responseData['interm_approval'];
                let intermFeildobj = {
                    name: 'interm_group',
                    data: [{
                        id: 1,
                        name: 'interim_amount',
                        title: 'Intial Approval',
                        visible: true,
                        element: 'input',
                        required: true,
                        input_type: 'number',
                        placeholder: 'Enter',
                        icon: 'user',
                        rules: [
                            {
                                test: (value) => {
                                    //return (value !== null && value.length > 0);
                                    return true;
                                },
                                message: 'Please Enter Submitted Amount'
                            }
                        ],
                        errors: [],
                        value: null,
                        valid: false,
                        state: '',
                        disable: true,
                        className: 'col-3'
                    }, {
                        id: 14,
                        name: 'case_no',
                        title: 'Additional Procedure',
                        visible: true,
                        element: 'input',
                        required: true,
                        input_type: 'text',
                        placeholder: 'Select',
                        icon: 'user',
                        rules: [
                            {
                                test: (value) => {
                                    //return (value !== null && value.length > 0);
                                    return true;
                                },
                                message: 'please select Additional Procedure'
                            }
                        ],
                        errors: [],
                        value: null,
                        valid: false,
                        state: '',
                        disable: true,
                        className: 'col-3'
                    }, {
                        id: 14,
                        name: 'aprox_bill',
                        title: 'Additional Procedure',
                        visible: true,
                        element: 'input',
                        required: true,
                        input_type: 'text',
                        placeholder: 'Select',
                        icon: 'user',
                        rules: [
                            {
                                test: (value) => {
                                    //return (value !== null && value.length > 0);
                                    return true;
                                },
                                message: 'please select Additional Procedure'
                            }
                        ],
                        errors: [],
                        value: null,
                        valid: false,
                        state: '',
                        disable: true,
                        className: 'col-3'
                    }]
                }
                let intermArray = [];
                if (interm_approval && Array.isArray(interm_approval)) {
                    interm_approval.map((data, key) => {
                        intermFeildobj['data'].map((feild, fkey) => {
                            // Object.keys(data).map(resKey => {
                            if (feild['name'] === 'case_no') {
                                intermFeildobj['data'][fkey]['value'] = interm_approval[key]['case_no'];
                                intermFeildobj['data'][fkey]['text'] = interm_approval[key]['case_no'];
                            }
                            if (feild['name'] === 'interim_amount') {
                                intermFeildobj['data'][fkey]['value'] = interm_approval[key]['interim_amount'];
                                intermFeildobj['data'][fkey]['text'] = interm_approval[key]['interim_amount'];
                                intermFeildobj['data'][fkey]['disable'] = true;
                            }
                            if (feild['name'] === 'aprox_bill') {
                                intermFeildobj['data'][fkey]['value'] = interm_approval[key]['approx_bill'];
                                intermFeildobj['data'][fkey]['text'] = interm_approval[key]['approx_bill'];
                            }

                            intermFeildobj['data'][fkey]['disable'] = true;
                            // })
                        })
                        intermArray.push(intermFeildobj);
                    })
                } else {
                    intermFeildobj['data'].map((feild, fkey) => {
                        // Object.keys(data).map(resKey => {

                        intermFeildobj['data'][fkey]['value'] = null;
                        intermFeildobj['data'][fkey]['text'] = null;
                        intermFeildobj['data'][fkey]['disable'] = true;



                        // })
                    })
                    intermArray.push(intermFeildobj);
                }


                let ailment_capping = responseData['ailment_capping'];
                let ailment_capping_array=[];
                let ailmentObj = {
                    name: 'interm_group',
                    data: [{
                        id: 14,
                        name: 'surgery',
                        title: 'Additional Procedure',
                        visible: true,
                        element: 'select2',
                        required: true,
                        input_type: 'select',
                        placeholder: 'Select',
                        icon: 'user',
                        rules: [
                            {
                                test: (value) => {
                                    //return (value !== null && value.length > 0);
                                    return true;
                                },
                                message: 'please select Additional Procedure'
                            }
                        ],
                        errors: [],
                        value: null,
                        valid: false,
                        state: '',
                        disable: false,
                        className: 'col-3'
                    }, {
                        id: 14,
                        name: 'surgery_amount',
                        title: 'Additional Procedure',
                        visible: true,
                        element: 'input',
                        required: true,
                        input_type: 'number',
                        placeholder: 'Select',
                        icon: 'user',
                        rules: [
                            {
                                test: (value) => {
                                    //return (value !== null && value.length > 0);
                                    return true;
                                },
                                message: 'please select Additional Procedure'
                            }
                        ],
                        errors: [],
                        value: null,
                        valid: false,
                        state: '',
                        disable: false,
                        className: 'col-3'
                    }]
                }; 
                if(ailment_capping && Array.isArray(ailment_capping)){
                    ailment_capping.map((data, key) => {
                        ailmentObj['data'].map((feild,fkey)=>{
                            if (feild['name'] === 'surgery') {
                                ailmentObj['data'][fkey]['value'] = ailment_capping[key]['surgery_id'];
                                ailmentObj['data'][fkey]['text'] = ailment_capping[key]['surgery_id_value'];
                            }
                            if (feild['name'] === 'surgery_amount') {
                                ailmentObj['data'][fkey]['value'] = ailment_capping[key]['surgery_amount'];
                                ailmentObj['data'][fkey]['text'] = ailment_capping[key]['surgery_amount'];
                            }
                            ailmentObj['data'][fkey]['disable'] = true;
                        })
                        ailment_capping_array.push(ailmentObj);
                    })                   
                }


                addonSchema.map((addonFeild, addKey) => {
                    Object.keys(responseData).map((feildKey) => {
                        if (addonFeild['name'] === feildKey) {
                            addonSchema[addKey]['value'] = responseData[feildKey];
                            addonSchema[addKey]['text'] = responseData[feildKey];
                            // total_est_chargs = total_est_chargs - parseFloat(responseData[feildKey]);
                            addonSchema[addKey]['disable'] = false;
                        }

                        if(addonFeild['name'] === 'Professional_charges'){
                            addonSchema[addKey]['value'] = responseData['professional_charges'];
                            addonSchema[addKey]['text'] = responseData['professional_charges'];
                            // total_est_chargs = total_est_chargs - parseFloat(responseData['professional_charges']);
                            addonSchema[addKey]['disable'] = false;
                        }

                        if(addonFeild['name'] === 'Physiotherapy_charges'){
                            addonSchema[addKey]['value'] = responseData['physiotherapy_charges'];
                            addonSchema[addKey]['text'] = responseData['physiotherapy_charges'];
                            // total_est_chargs = total_est_chargs - parseFloat(responseData['physiotherapy_charges']);
                            addonSchema[addKey]['disable'] = false;
                        }
                        if(addonFeild['name'] === 'room_charges'){
                            
                            addonSchema[addKey]['disable'] = true;
                        }
                        addonSchema[addKey]['disable'] = true;


                    })
                })


                console.clear();
                this.setState((state) => ({ 'total_estimate': responseData ? responseData['total_estimate_amount'] : 0,'addonSchema':addonSchema,'ailmentFrorm':ailment_capping_array,'preExistingForm': preExistingArray, 'intermForm': intermArray, 'formData': formData, 'formData2': formData2, 'formData3': formData3 }), () => {
                    // this.caluculateTotal();
                });

            }

        }).catch((error) => {
            this.setState((state) => ({ loadding: false }));
            console.log(error);
            Modal.error({
                title: 'Error Message',
                content: 'Some Thing went wrong,Please try again. later',

            })
        });
    }
    printView = () => { 
        const params = new URLSearchParams(this.props.location.search);
        const tags = params.get('rid');
        const umr_no = params.get('umr');
        const unit_id = params.get('unit_id');
        
        let { getCounsellingPrintDetails } = networkList;
        let { print_payment_type }=this.state
        if(tags && print_payment_type){
            postService(getCounsellingPrintDetails, 'POST', { data: { "counselling_id": parseInt(tags),"payment_type": print_payment_type }   }).then(res => {
                console.log('getCounsellingPrintDetails:',res);               
                this.setState((state) => ({ loadding: false }));
                if (res.status) {
                    Storage.store('print_response', res['data']);
                    if(unit_id){
                        this.props.history.push(`/counselling/counselling-print?nav_from=view-finanical-counselling?umr=${umr_no}&unit_id=${unit_id}`);
                    }else{
                        this.props.history.push(`/counselling/counselling-print?nav_from=view-insurance-counselling`);
                    }
                } else {
                    Modal.error({
                        title: 'Error Message',
                        content: 'Some Thing went wrong,Please try again. later',

                    })
                }
                }).catch((error) => {
                    this.setState((state) => ({ loadding: false }));
                    console.log(error);
                    Modal.error({
                        title: 'Error Message',
                        content: 'Some Thing went wrong,Please try again. later',
    
                    })
                });
        }else {
            this.setState((state) => ({ loadding: false }));           
            Modal.error({
                title: 'Error Message',
                content: 'Some Thing went wrong,Please try again. later',

            })
        }
       
    }

    render() {
        let { formData, formData2, addonSchema, total_estimate, formData3, preExistince, preExistingForm, intermForm, alinmentTable, ailmentFrorm, preExistFormFEild, nav_from } = this.state;
        console.log(preExistingForm);
        return (
            <div className="row m-5">
            <div className="col-10 p-0">
                <div className="card py-4">
                    <h1 className="text-center text-capitalize text-heading mb-0">Insurance Counselling</h1>
                    <div className="row p-4 align-items-end">

                        {formData
                            .map((feild, key) => {

                                if (feild.element === 'input' && feild.visible) {
                                    return (

                                        <div
                                            className={`${feild.className
                                                ? feild.className
                                                : 'col'} my-2 ${feild.name}`}
                                            key={key}>
                                            <div className="clearfix">
                                                <p className="data-label w-100 mb-1 pt-2 float-left">{feild.title}</p>
                                            </div>
                                            <Inputlayer
                                                {...this.props}
                                                {...this.state}
                                                feildData={feild}
                                                onInputChanges={(e)=>console.log(e)}
                                            />
                                        </div>

                                    )
                                }
                                if (feild.element === 'checkbox') {
                                    return (
                                        <div
                                            className={`${feild.className
                                                ? feild.className
                                                : 'col'} pt-2 my-2 ${feild.name}`}
                                            key={key}>
                                            <input type="checkbox" id={feild.title} name={feild.title} value={feild.title} /> <label for={feild.title} className="data-label w-75">  {feild.title}</label>
                                        </div>

                                    )
                                }
                                
                                if (feild.element === 'select2' && feild.visible) {
                                    return (
                                        <React.Fragment key={key}>
                                            {(feild.name === 'patient_list' && feild.disable === false) &&
                                                <div className="col-6">
                                                    <p className="mb-0 text-black pl-0" style={{ fontSize: 13 + 'px', lineHeight: 2, backgroundColor: 'transparent' }}><span className="text-info" style={{ fontSize: 15 + 'px', lineHeight: 2 }}>Note:</span> Please Select Patient List</p>
                                                </div>}
                                            <div
                                                className={`${feild.className
                                                    ? feild.className
                                                    : 'col '} my-2 ${feild.name}`}
                                                key={key}>
                                                <p className="data-label w-100 mb-1 pt-2">{feild.title}</p>
                                                <Select2
                                                    Queuedata={formData}
                                                    selectdata={feild}
                                                    {...this.props}
                                                    {...this.state}
                                                    onselectChanges={(e)=>console.log(e)}
                                                /> {feild
                                                    .errors
                                                    .map((error, eKey) => {
                                                        return (
                                                            <small key={eKey} className="form-text text-danger">{error.message}</small>
                                                        );
                                                    })}
                                            </div>
                                        </React.Fragment>
                                    )
                                }
                                if (feild.element === 'select2multiple' && feild.visible) {
                                    return (
                                        <React.Fragment key={key}>
                                            {(feild.name === 'patient_list' && feild.disable === false) &&
                                                <div className="col-6">
                                                    <p className="mb-0 text-black pl-0" style={{ fontSize: 13 + 'px', lineHeight: 2, backgroundColor: 'transparent' }}><span className="text-info" style={{ fontSize: 15 + 'px', lineHeight: 2 }}>Note:</span> Please Select Patient List</p>
                                                </div>}
                                            <div
                                                className={`${feild.className
                                                    ? feild.className
                                                    : 'col '} my-2 ${feild.name}`}
                                                key={key}>
                                                <p className="data-label w-100 mb-1 pt-2">{feild.title}</p>
                                                <Select2multiple
                                                    Queuedata={formData}
                                                    selectdata={feild}
                                                    {...this.props}
                                                    {...this.state}
                                                    onselectChanges={(e)=>console.log(e)}
                                                /> {feild
                                                    .errors
                                                    .map((error, eKey) => {
                                                        return (
                                                            <small key={eKey} className="form-text text-danger">{error.message}</small>
                                                        );
                                                    })}
                                            </div>
                                        </React.Fragment>
                                    )
                                }



                                if (feild.element === 'select3') {
                                    return (
                                        <div
                                            className={`${feild.className
                                                ? feild.className
                                                : 'col'} my-2 ${feild.name}`}
                                            key={key}>
                                            <p className="data-label w-100 mb-1 pt-2">{feild.title}</p>
                                            <Input.Group compact>

                                                {feild['data'].map((subFeild, subkey) => {
                                                    if (subFeild.element === 'select2' && subFeild.visible) {
                                                        return (
                                                            <React.Fragment key={subkey}>
                                                                <Select2
                                                                    Queuedata={formData}
                                                                    selectdata={subFeild}
                                                                    {...this.props}
                                                                    {...this.state}
                                                                    onselectChanges={(e) => console.log(e)}
                                                                /> {subFeild
                                                                    .errors
                                                                    .map((error, eKey) => {
                                                                        return (
                                                                            <small key={eKey} className="form-text text-danger">{error.message}</small>
                                                                        );
                                                                    })}


                                                            </React.Fragment>
                                                        )
                                                    }
                                                })}
                                                {/* <Select defaultValue="Select">
                                                    <Option value="Select">Select</Option>
                                                    <Option value="Yes">Yes</Option>
                                                    <Option value="No">No</Option>
                                                </Select>
                                                <Input style={{ width: '30%' }} defaultValue="" placeholder="Amount" /> */}
                                            </Input.Group>
                                        </div>

                                    )
                                }
                                if (feild.element === 'input2') {
                                    return (
                                        <div
                                            className={`${feild.className
                                                ? feild.className
                                                : 'col'} my-2 ${feild.name}`}
                                            key={key}>
                                            <p className="data-label w-100 mb-1 pt-2">{feild.title}</p>
                                            <Input.Group compact>
                                                <Input style={{ width: '30%' }} defaultValue="" placeholder="%" />
                                                <Input style={{ width: '70%' }} defaultValue="" placeholder="Amount" />
                                            </Input.Group>
                                        </div>

                                    )
                                }

                                if (feild.element === 'date' && feild.visible) {
                                    return (
                                        <div
                                            className={`${feild.className
                                                ? feild.className
                                                : 'col '} my-2 ${feild.name}`}
                                            key={key}>
                                            <p className="data-label w-100 mb-1 pt-2">{feild.title}</p>
                                            <Datepicker
                                                // Queuedata={filtereData}
                                                selectdata={feild}
                                                {...this.props}
                                                {...this.state}
                                                onselectChanges={(e)=>console.log(e)}
                                            // onselectChanges={this
                                            //     .onChange
                                            //     .bind(this)} 
                                            />
                                        </div>
                                    )

                                }

                            })}
                    </div>
                    {(preExistince) &&
                        <div className="financial-table table-responsive">
                            <div className="d-inline-flex pl-5 w-100">
                                <h4 className="data-label w-25" style={{ fontSize: 20 }}>Pre-Existing Conditions</h4>
                            </div>
                            <table className="table table-hover table-bordered mb-0">
                                <thead>
                                    <tr>
                                        <td>S.no</td>
                                        <td>Condition</td>
                                        <td>Onset Date</td>
                                        <td>Sum Insured at Onset Date</td>
                                        <td>consider SI</td>
                                       
                                    </tr>
                                </thead>
                                <tbody>
                                    {(preExistingForm !== undefined) && <React.Fragment>
                                        {preExistingForm.map((preForm, preKey) => {
                                            console.log(preForm);
                                            return (<tr key={preKey}>
                                                <td>{preKey + 1}</td>
                                                {preForm['data'].map((feild, key) => {
                                                
                                                    if (feild.element === 'input' && feild.visible) {
                                                        return (

                                                            <td>
                                                                <Inputlayer
                                                                    {...this.props}
                                                                    {...this.state}
                                                                    feildData={feild}
                                                                    onInputChanges={(e)=>console.log(e)}
                                                                /></td>


                                                        )
                                                    }
                                                    if (feild.element === 'select2' && feild.visible) {

                                                       


                                                        return (

                                                            <td>
                                                                <Select2
                                                                    Queuedata={formData}
                                                                    selectdata={feild}
                                                                    {...this.props}
                                                                    {...this.state}
                                                                    onselectChanges={(e)=>console.log(e)}
                                                                /></td>

                                                        )
                                                    }
                                                    if (feild.element === 'date' && feild.visible) {
                                                        return (
                                                            <td>
                                                                <Datepicker
                                                                    // Queuedata={filtereData}
                                                                    selectdata={feild}
                                                                    {...this.props}
                                                                    {...this.state}
                                                                    onselectChanges={(e)=>console.log(e)}
                                                                // onselectChanges={this
                                                                //     .onChange
                                                                //     .bind(this)} 
                                                                /></td>

                                                        )

                                                    }

                                                    if (feild.element === 'checkbox') {
                                                        return (
                                                            <td>
                                                                <CheckboxLayer
                                                                    selectdata={feild}
                                                                    {...this.props}
                                                                    {...this.state}

                                                                    onselectChanges={(e)=>console.log(e)}
                                                                /></td>


                                                        )
                                                    }

                                                })}
                                            </tr>)
                                        })}

                                    </React.Fragment>}
                                    <tr>

                                        <td colSpan="2">Sum Insured For Four Years Back</td>
                                        {(preExistFormFEild !== undefined) && <React.Fragment>
                                            {preExistFormFEild.map((feild, key) => {
                                                if (feild.element === 'input' && feild.visible) {
                                                    return (
                                                        <td key={key} colSpan={key === 0 ? '2' : 1}>
                                                            <Inputlayer
                                                                {...this.props}
                                                                {...this.state}
                                                                feildData={feild}
                                                                onInputChanges={(e)=>console.log(e)}
                                                            /></td>
                                                    )
                                                }
                                                if (feild.element === 'checkbox') {
                                                    return (
                                                        <td colSpan="2">
                                                            <CheckboxLayer
                                                                selectdata={feild}
                                                                {...this.props}
                                                                {...this.state}

                                                                onselectChanges={(e)=>console.log(e)}
                                                            /></td>


                                                    )
                                                }
                                            })}
                                        </React.Fragment>}

                                    </tr>
                                   

                                </tbody>
                            </table>
                        </div>}
                    <div className="row p-4 align-items-end">

                        {(formData2) && <React.Fragment>
                            {formData2
                                .map((feild, key) => {

                                    if (feild.element === 'input') {
                                        return (

                                            <div
                                                className={`${feild.className
                                                    ? feild.className
                                                    : 'col'} my-2 ${feild.name}`}
                                                key={key}>
                                                <p className="data-label w-100 mb-1 pt-2">{feild.title}</p>
                                                <Inputlayer
                                                    {...this.props}
                                                    {...this.state}
                                                    feildData={feild}
                                                    onInputChanges={(e)=>console.log(e)}
                                                />
                                            </div>

                                        )
                                    } 
                                    if (feild.element === 'select2') {
                                        return (
                                            <React.Fragment key={key}>
                                                {(feild.name === 'patient_list' && feild.disable === false) &&
                                                    <div className="col-6">
                                                        <p className="mb-0 text-black pl-0" style={{ fontSize: 13 + 'px', lineHeight: 2, backgroundColor: 'transparent' }}><span className="text-info" style={{ fontSize: 15 + 'px', lineHeight: 2 }}>Note:</span> Please Select Patient List</p>
                                                    </div>}
                                                <div
                                                    className={`${feild.className
                                                        ? feild.className
                                                        : 'col '} my-2 ${feild.name}`}
                                                    key={key}>
                                                    <p className="data-label w-100 mb-1 pt-2">{feild.title}</p>
                                                    <Select2
                                                        Queuedata={formData}
                                                        selectdata={feild}
                                                        {...this.props}
                                                        {...this.state}
                                                        onselectChanges={(e)=>console.log(e)}
                                                    /> {feild
                                                        .errors
                                                        .map((error, eKey) => {
                                                            return (
                                                                <small key={eKey} className="form-text text-danger">{error.message}</small>
                                                            );
                                                        })}
                                                </div>
                                            </React.Fragment>
                                        )
                                    }
                                    if (feild.element === 'select3') {
                                        return (
                                            <div
                                                className={`${feild.className
                                                    ? feild.className
                                                    : 'col'} my-2 ${feild.name}`}
                                                key={key}>
                                                <p className="data-label w-100 mb-1 pt-2">{feild.title}</p>
                                                <div className="row">

                                                    {feild['data'].map((subFeild, subkey) => {
                                                        if (subFeild.element === 'select2' && subFeild.visible) {
                                                            return (
                                                                <React.Fragment key={subkey}>
                                                                    <div className="col-7 pr-0">
                                                                        <Select2
                                                                            Queuedata={formData2}
                                                                            selectdata={subFeild}
                                                                            {...this.props}
                                                                            {...this.state}
                                                                            onselectChanges={(e)=>console.log(e)}
                                                                        /> {subFeild
                                                                            .errors
                                                                            .map((error, eKey) => {
                                                                                return (
                                                                                    <small key={eKey} className="form-text text-danger">{error.message}</small>
                                                                                );
                                                                            })}
                                                                    </div>
                                                                </React.Fragment>
                                                            )
                                                        }
                                                        if (subFeild.element === 'input' && subFeild.visible) {
                                                            return (
                                                                <React.Fragment key={subkey}>
                                                                    <div className="col-5 pl-0">
                                                                        <Inputlayer
                                                                            {...this.props}
                                                                            {...this.state}
                                                                            feildData={subFeild}
                                                                            onInputChanges={(e)=>console.log(e)}
                                                                        />
                                                                    </div>
                                                                </React.Fragment>
                                                            )
                                                        }
                                                    })}

                                                    {/* <Select defaultValue="Select">
                                                        <Option value="Select">Select</Option>
                                                        <Option value="Yes">Yes</Option>
                                                        <Option value="No">No</Option>
                                                    </Select>
                                                    <Input style={{ width: '40%' }} defaultValue="" placeholder="Amount" /> */}
                                                </div>
                                            </div>

                                        )
                                    }
                                    if (feild.element === 'input2') {
                                        return (
                                            <div
                                                className={`${feild.className
                                                    ? feild.className
                                                    : 'col'} my-2 ${feild.name}`}
                                                key={key}>
                                                <p className="data-label w-100 mb-1 pt-2">{feild.title}</p>
                                                {/* <Input.Group compact>
                                                    <Input style={{ width: '30%' }} defaultValue="" placeholder="%" />
                                                    <Input style={{ width: '70%' }} defaultValue="" placeholder="Amount" />
                                                </Input.Group> */}
                                                <div className="row">

                                                    {feild['data'].map((subFeild, subkey) => {
                                                        if (subFeild.element === 'select2' && subFeild.visible) {
                                                            return (
                                                                <React.Fragment key={subkey}>
                                                                    <div className="col-7 pr-0">
                                                                        <Select2
                                                                            Queuedata={formData2}
                                                                            selectdata={subFeild}
                                                                            {...this.props}
                                                                            {...this.state}
                                                                            onselectChanges={(e)=>console.log(e)}
                                                                        /> {subFeild
                                                                            .errors
                                                                            .map((error, eKey) => {
                                                                                return (
                                                                                    <small key={eKey} className="form-text text-danger">{error.message}</small>
                                                                                );
                                                                            })}
                                                                    </div>
                                                                </React.Fragment>
                                                            )
                                                        }
                                                        if (subFeild.element === 'input' && subFeild.visible) {
                                                            return (
                                                                <React.Fragment key={subkey}>
                                                                    <div className={subkey === 0 ? "col-5 pr-0" : "col-7 pl-0"} >
                                                                        <Inputlayer
                                                                            {...this.props}
                                                                            {...this.state}
                                                                            feildData={subFeild}
                                                                            onInputChanges={(e)=>console.log(e)}
                                                                        />
                                                                    </div>
                                                                </React.Fragment>
                                                            )
                                                        }
                                                    })}


                                                </div>
                                            </div>

                                        )
                                    }
                                    // if (feild.element === 'checkbox') {
                                    //     return (
                                    //         <div
                                    //             className={`${feild.className
                                    //                 ? feild.className
                                    //                 : 'col'} my-2 ${feild.name}`}
                                    //             key={key}>
                                    //             <input type="checkbox" id={feild.title} name={feild.title} value={feild.title} /> <label for={feild.title} className="data-label">  {feild.title}</label>
                                    //         </div>

                                    //     )
                                    // }
                                })}

                        </React.Fragment>}
                    </div>

                    {(alinmentTable) &&
                        <div className="financial-table table-responsive">
                            <div className="d-inline-flex pl-5 w-100">
                                <h4 className="data-label w-25" style={{ fontSize: 20 }}>Ailment Capping</h4>
                            </div>
                            <table className="table table-hover table-bordered mb-0">
                                <thead>
                                    <tr>
                                        <td>S.no</td>
                                        <td>Procedure</td>
                                        <td>Cost</td>
                                        <td>Actions</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {(ailmentFrorm !== undefined) && <React.Fragment>
                                        {ailmentFrorm.map((preForm, preKey) => {
                                            return (<tr key={preKey}>
                                                <td>{preKey + 1}</td>
                                                {preForm['data'].map((feild, key) => {

                                                    if (feild.element === 'input' && feild.visible) {
                                                        return (

                                                            <td>
                                                                <Inputlayer
                                                                    {...this.props}
                                                                    {...this.state}
                                                                    feildData={feild}
                                                                    onInputChanges={(e)=>console.log(e)}
                                                                /></td>


                                                        )
                                                    }
                                                    if (feild.element === 'select2' && feild.visible) {
                                                        return (

                                                            <td>
                                                                <Select2
                                                                    Queuedata={formData}
                                                                    selectdata={feild}
                                                                    {...this.props}
                                                                    {...this.state}
                                                                    onselectChanges={(e)=>console.log(e)}
                                                                /></td>

                                                        )
                                                    }
                                                    if (feild.element === 'date' && feild.visible) {
                                                        return (
                                                            <td>
                                                                <Datepicker
                                                                    // Queuedata={filtereData}
                                                                    selectdata={feild}
                                                                    {...this.props}
                                                                    {...this.state}
                                                                    onselectChanges={(e)=>console.log(e)}
                                                                // onselectChanges={this
                                                                //     .onChange
                                                                //     .bind(this)} 
                                                                /></td>

                                                        )

                                                    }

                                                    if (feild.element === 'checkbox') {
                                                        return (
                                                            <td>
                                                                <CheckboxLayer
                                                                    selectdata={feild}
                                                                    {...this.props}
                                                                    {...this.state}

                                                                    onselectChanges={(e)=>console.log(e)}
                                                                /></td>


                                                        )
                                                    }

                                                })}

                                               
                                                {/* <td>{((preKey + 1) !== ailmentFrorm.length) && <img src="/assets/images/icons/delete.png" alt="edit" title="edit" className="mr-2" onClick={this.deleteRow.bind(this, preKey, 'ailment')} />}</td> */}
                                            </tr>)
                                        })}

                                    </React.Fragment>}
                                    {/* <tr>
                                        <td colSpan="6" className="text-right">
                                            <button className="btn btn-success" onClick={this.addrow.bind(this, 'ailment')}>Add Ailment</button>
                                        </td>
                                    </tr> */}


                                </tbody>
                            </table>
                        </div>}

                    <div className="row mt-4 pl-2">
                        <div className="d-inline-flex pl-5 w-100">
                            <h4 className="data-label w-25" style={{ fontSize: 20 }}>Interim Details</h4>
                        </div>
                        {/* <div className="col-xl-3">
                            <p className="data-label w-100 mb-1 pt-2">Initial Approval Amount*</p>
                            <Input placeholder="Enter" />
                        </div> */}
                        {/* <div className="col-xl-3 offset-6">
                            <button type="button" className="btn btn-success float-right mt-3" id="" name="">Add Interim Approval</button>
                        </div> */}
                    </div>
                    <div className="financial-table table-responsive">
                        <table className="table table-hover table-bordered mb-0">
                            <thead>
                                <tr>
                                    <td>S.no</td>
                                    <td>Interim Approval</td>
                                    <td>Case No.</td>
                                    <td>Approx Bill</td>
                                    
                                </tr>
                            </thead>
                            <tbody>
                                {(intermForm !== undefined) && <React.Fragment>
                                    {intermForm.map((preForm, preKey) => {
                                        return (<tr key={preKey}>
                                            <td>{preKey + 1}</td>
                                            {preForm['data'].map((feild, key) => {

                                                if (feild.element === 'input' && feild.visible) {
                                                    return (

                                                        <td>
                                                            <Inputlayer
                                                                Queuedata={formData}
                                                                {...this.props}
                                                                {...this.state}
                                                                feildData={feild}
                                                                onInputChanges={(e)=>console.log(e)}
                                                            /></td>


                                                    )
                                                }
                                                if (feild.element === 'select2' && feild.visible) {
                                                    return (

                                                        <td>
                                                            <Select2
                                                                Queuedata={formData}
                                                                selectdata={feild}
                                                                {...this.props}
                                                                {...this.state}
                                                                onselectChanges={(e)=>console.log(e)}
                                                            /></td>

                                                    )
                                                }
                                                if (feild.element === 'date' && feild.visible) {
                                                    return (
                                                        <td>
                                                            <Datepicker
                                                                // Queuedata={filtereData}
                                                                selectdata={feild}
                                                                {...this.props}
                                                                {...this.state}
                                                                onselectChanges={(e)=>console.log(e)}
                                                            // onselectChanges={this
                                                            //     .onChange
                                                            //     .bind(this)} 
                                                            /></td>

                                                    )

                                                }

                                            })}
                                           </tr>)
                                    })}

                                </React.Fragment>}
                                {/* <tr>
                                        <td colSpan="4" className="text-right">
                                            <button className="btn btn-success" onClick={this.addrow.bind(this, 'intermForm')}>Add Intrem</button>
                                        </td>
                                    </tr> */}

                            </tbody>
                        </table>
                    </div>

                    <div className="row my-3 mx-0">
                        <React.Fragment>
                            <div className="clearfix float-right col-12 mt-3">
                                <h1 className="text-capitalize text-heading float-left">Total Estimated Amount</h1>
                                <h1 className="text-capitalize text-heading  float-right">Rs. {total_estimate}</h1>
                            </div>
                            <div className="financial-table table-responsive">
                                <table className="table table-hover table-bordered">
                                    <thead>
                                        <tr>
                                            <td>S.no</td>
                                            <td>Service Groups</td>
                                            <td className="w-50">Specification</td>
                                            <td>Approx Amount</td>
                                        </tr>
                                    </thead>
                                    {(addonSchema !== undefined) &&
                                        <tbody>
                                            {addonSchema.map((feild, key) => {
                                                return (<tr key={key}>
                                                    <td>{key + 1}</td>
                                                    <td>{feild.service_group}</td>
                                                    <td>
                                                        <ul>
                                                            {feild['Specification'].map((spec, spek) => {
                                                                return (<li key={spek}>{spec}</li>)
                                                            })}
                                                        </ul>
                                                    </td>
                                                    <td style={{ verticalAlign: 'middle' }}>
                                                        {(feild.element === 'input' && feild.visible) &&
                                                            <div className="row m-0">
                                                                <div
                                                                    className="col-12 p-0"
                                                                    key={key}>
                                                                    <Inputlayer
                                                                        {...this.props}
                                                                        {...this.state}
                                                                        feildData={feild}
                                                                        onInputChanges={(e)=>console.log(e)}
                                                                    />
                                                                    {(feild.name === 'ipnumber') && <Button type="primary" icon="search"></Button>}
                                                                </div>
                                                            </div>


                                                        }
                                                    </td>

                                                </tr>)
                                            })}


                                        </tbody>
                                    }
                                </table>
                            </div>
                        </React.Fragment>
                    </div>

                    <div className="row p-4">
                        {(formData3) && <React.Fragment>
                            {formData3
                                .map((feild, key) => {

                                    if (feild.element === 'input') {
                                        return (

                                            <div
                                                className={`${feild.className
                                                    ? feild.className
                                                    : 'col'} my-2 ${feild.name}`}
                                                key={key}>
                                                <p className="data-label w-100 mb-1 pt-2 float-left">{feild.title}</p>
                                                <Inputlayer
                                                    {...this.props}
                                                    {...this.state}
                                                    feildData={feild}
                                                    onInputChanges={(e)=>console.log(e)}
                                                />
                                            </div>

                                        )
                                    }
                                    if (feild.element === 'select2') {
                                        return (
                                            <React.Fragment key={key}>
                                                {(feild.name === 'patient_list' && feild.disable === false) &&
                                                    <div className="col-6">
                                                        <p className="mb-0 text-black pl-0" style={{ fontSize: 13 + 'px', lineHeight: 2, backgroundColor: 'transparent' }}><span className="text-info" style={{ fontSize: 15 + 'px', lineHeight: 2 }}>Note:</span> Please Select Patient List</p>
                                                    </div>}
                                                <div
                                                    className={`${feild.className
                                                        ? feild.className
                                                        : 'col '} my-2 ${feild.name}`}
                                                    key={key}>
                                                    <p className="data-label w-100 mb-1 pt-2">{feild.title}</p>
                                                    <Select2
                                                        Queuedata={formData}
                                                        selectdata={feild}
                                                        {...this.props}
                                                        {...this.state}
                                                        onselectChanges={(e)=>console.log(e)}
                                                    /> {feild
                                                        .errors
                                                        .map((error, eKey) => {
                                                            return (
                                                                <small key={eKey} className="form-text text-danger">{error.message}</small>
                                                            );
                                                        })}
                                                </div>
                                            </React.Fragment>
                                        )
                                    }
                                })}
                        </React.Fragment>}
                    </div>

                    <div className="insurance px-4">
                        <h5 className="data-label w-100">Insurance:</h5>

                        <ul className="pl-3">
                            <li>Insurance Processing Charges (one time charge) will be billed in addition to the above charges for every patient admission.</li>
                            <li>In case a higher category room (beyond eligibility) is opted for, pro rata charges will be levied to you for all services availed. </li>
                            <li>List of Non-Medical Expenses & Insurance Checklist have been provided to you.</li>
                        </ul>
                        <p className="one">Please note that all the above costs are quoted for the stipulated / tentative length of stay. Increase in length of stay or increase in OT
                        time due to clinical complications/comorbidities will elicit additional charges, depending on the complexity of condition / extension of
treatment / period</p>
                        <p className="two mb-2">For cash paying patients, an advance of 80% of the total estimated amount shall be paid at the time of admission by Cash/Card.</p>
                        <p className="two mb-2">All cash paying patients shall maintain a positive cash balance at any time during their stay for medical treatment in the hospital.</p>
                        <p className="two mb-2">Excess Amount paid (upto Rs 10,000) will be refunded to you in cash immediately at the time of final bill clearance.</p>
                        <p className="two mb-2">As per IT Section 269 ST, amount upto Rs 1,99,999 only will be accepted in Cash. Payment above Rs 2,00,000 can be paid
through NEFT/DD/Card</p>
                    </div>
                    <div className="row justify-content-center mt-3">
                    {( nav_from !== 'bill-details')  && <React.Fragment>
                    <button className="btn btn-success btn-next text-capitalize mr-3" onClick={this.printView.bind(this)}>Print View</button>
                    </React.Fragment>}
                        <button className="btn btn-success btn-next text-capitalize" onClick={this.cancelButton.bind(this)}>Back</button>
                    </div>
                </div>               
                   </div>
                   <div className="col-2 pl-1 pr-0 mb-5">
                <div className="card p-3 right-panel-sticky">
                    <h4 className="text-center pb-3">Other Info</h4>
                   <Ins_upload {...this.props} {...this.state} />
                   <Finanical_clearance {...this.props} {...this.state} />
                    </div>
                   </div>
                {(this.state.loadding) &&
                    <div className="loadding"> <Spin  tip="Loading..." size={'large'}></Spin></div>}
            </div>
        )

    }
}
export default View_Insurance_Counselling;